module.exports = __webpack_public_path__ + "static/media/writing.14a49507.gif";